import { Spinner, Stack, useMediaQuery } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import { useLocation } from 'react-router-dom';
import {
  IAspectsAndTopicsProps,
  useGetTitlesTopicsData,
} from '../../../../services/hooks/Titles/useGetTitlesTopicsData';
import TitlesMobilePage from './TitlesMobilePage';
import TitlesContentPage from './TitlesContent';

const TitlesCandidateArea: React.FC = () => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');
  const registrationId = useLocation().pathname.split('/')[2];
  const stepId = useLocation().pathname.split('/')[4];
  const titlesData = useGetTitlesTopicsData<IAspectsAndTopicsProps[]>({
    remove_pagination: true,
    registrationId: registrationId,
    step_id: stepId,
  });

  const isLoadingData = titlesData.isLoading;

  if (isMobile)
    return (
      <TitlesMobilePage>
        <TitlesContentPage isMobile />
      </TitlesMobilePage>
    );

  return (
    <>
      <MainCard title="ÁREA DO CANDIDATO " subtitle="- ENVIO DE TÍTULOS">
        {isLoadingData ? (
          <Stack align="center" justify="center">
            <Spinner />
          </Stack>
        ) : (
          <TitlesContentPage />
        )}
      </MainCard>
    </>
  );
};

export default TitlesCandidateArea;
